'use client'

import { useTranslations } from 'next-intl'
import { usePathname, useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'

import Button from '@/components/ui/Button'
import Icon from '@/components/ui/icon'
import { CategoryFilters, FilteredCategory } from '@/types/category.type'

import FilterMobile from './FilterMobile'

type ActionMobileProps = {
  name: string
  total: number
  searchParams: any
  filters: CategoryFilters
  filtered: FilteredCategory['filtered']
  totalProduct: number
  totalInStock: number
}

export default function ActionMobile({ name, searchParams, total, filters, filtered, totalProduct, totalInStock }: ActionMobileProps) {
  const [orderSort, setOrderSort] = useState(searchParams.order_sort || '3')
  const [openSort, setOpenSort] = useState(false)
  const [filterOpen, setFilterOpen] = useState(false)
  const [totalSort, setTotalSort] = useState(0) // tổng số brand và prid được chọn
  const [brands, setBrands] = useState<number[]>([])
  const [prids, setPrids] = useState<number[]>([])
  const [stock, setStock] = useState<number[]>([])
  const t = useTranslations('product')
  const router = useRouter()
  const pathname = usePathname()

  const sorts = [
    { id: '3', name: t('inventory') },
    { id: '1', name: t('name') },
    { id: '2', name: t('price') },
    { id: '4', name: t('newest') },
    { id: '5', name: t('default') },
  ]

  const handleChangeSelect = (value: string) => {
    setOrderSort(value)
    handleSelect(value)
    setOpenSort(false)
  }

  const handleSelect = (value: string | number) => {
    const params = new URLSearchParams(searchParams)
    params.set('order_sort', String(value))
    params.delete('page')
    router.push(`${pathname}?${params.toString()}`, { scroll: true })
  }

  useEffect(() => {
    const order = searchParams.order_sort
    const brands = (searchParams.brand ?? '').split(',').filter(Boolean).map(Number)
    const prids = (searchParams.prid ?? '').split(',').filter(Boolean).map(Number)
    const stock = searchParams.in_stock ? [Number(searchParams.in_stock)] : []
    const total = brands.length + prids.length + stock.length

    if (order) {
      setOrderSort(order)
    }

    setBrands(brands)
    setPrids(prids)
    setStock(stock)
    setTotalSort(total)
  }, [searchParams])

  return (
    <>
      {filterOpen && <FilterMobile filteredData={filtered} filters={filters} onClose={() => setFilterOpen(false)} brands={brands} prids={prids} stock={stock} totalProduct={totalProduct} totalInStock={totalInStock}/>}
      <div className="block lg:hidden sticky top-[5px] z-[10] bg-white">
        <div className="p-2 leading-[25px] bg-white text-[17px] font-medium text-thegioiic-gray">
          {name} {total > 0 && <span>({total})</span>}
        </div>
        <div className="p-2 grid grid-cols-2 gap-4">
          <Button size="xs" outline thegioiicGray full onClick={() => setFilterOpen(true)} className="!h-[30px]">
            <Icon icon="tgic icon-filter-solid" className="text-base" />
            <span className="text-sm">
              {t('filter')} {totalSort > 0 && <span>({totalSort})</span>}
            </span>
          </Button>
          <div className="relative">
            <Button size="xs" outline thegioiicGray full onClick={() => setOpenSort(!openSort)} className="!h-[30px]">
              <Icon icon="tgic icon-arrow-down-short-wide" className="text-base mr-1" />
              <span className="text-sm">{searchParams.order_sort ? sorts.find((s) => s.id === orderSort)?.name : t('sort')}</span>
            </Button>
            {openSort && (
              <div className="absolute w-full bg-white z-[99] left-0 top-full shadow-[0_0.15rem_1.75rem_0_rgba(58,59,69,0.15)] p-[5px]">
                {sorts.map((sort) => (
                  <label key={`order-sort-${sort.id}`} htmlFor={`sort-${sort.id}`} className="my-1 block">
                    <input id={`sort-${sort.id}`} className="ml-[5px] mr-[3px]" type="radio" checked={orderSort === sort.id} onChange={() => handleChangeSelect(sort.id)} />
                    <span>{sort.name}</span>
                  </label>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
